import { useQuery } from '@tanstack/react-query'
import { getDeadlineRequests } from '../../deadline-requests/api/deadlineRequestsApi'
import { DEADLINE_REQUESTS_LIST_KEY } from '../../deadline-requests/hooks/useDeadlineRequests'
import { DEADLINE_REQUEST_STATUS, DEADLINE_REQUEST_TAB } from '../../deadline-requests/types'
import { useMeetingManagementTasks } from '../../meetingManagement/hooks/useMeetingManagement'
import { TASK_CLOSURE_DEFAULT_SORT, TASK_CLOSURE_QUERY } from '../types'

/**
 * Sekme başlıklarındaki bekleyen kayıt sayıları (131 FR-021). Yeni bir "sayı" ucu yoktur: her sayı,
 * sekmenin listelediği kümeyi okuyan <b>aynı</b> uca `size=1` ile sorulur ve `totalElements` okunur —
 * sayı ile liste aynı sorgudan geldiği için ayrışamaz.
 *
 * <ul>
 *   <li><b>Talepler</b>: onay kuyruğundaki <b>Beklemede</b> talepler. Sekmedeki durum süzgecinden
 *       bağımsızdır — kullanıcı "Tüm Durumlar"ı seçse de başlık yapılacak işi gösterir.
 *   <li><b>Görevler</b>: sekmenin sabit sorgusu (Onay Bekleniyor ana görevler).
 * </ul>
 *
 * <p>Sorgu anahtarları ilgili listelerin <b>kökündedir</b>: onay/ret ve kapat/yeniden aç mutasyonları
 * o kökleri zaten geçersiz kıldığı için sayı karardan sonra kendiliğinden güncellenir.
 *
 * <p>Görünmeyen sekmenin sorgusu <b>hiç gönderilmez</b>: uç yetkisiz kullanıcıya 403 döner ve merkezî
 * hata bildirimi kullanıcının istemediği bir hatayı gösterirdi.
 */
export function useApprovalCounts(visible: { requests: boolean; tasks: boolean }) {
  const requests = useQuery({
    queryKey: [...DEADLINE_REQUESTS_LIST_KEY, 'pending-count'],
    queryFn: () =>
      getDeadlineRequests({
        tab: DEADLINE_REQUEST_TAB.INBOX,
        statusId: DEADLINE_REQUEST_STATUS.PENDING,
        page: 0,
        size: 1,
      }),
    enabled: visible.requests,
  })
  // Sıra sayıyı değiştirmez; yine de sekmenin sırası verilir: verilmezse sunucu varsayılan sıranın
  // (durum + gecikme alt sorguları) maliyetini tek kayıtlık bir istek için boşuna öder.
  const tasks = useMeetingManagementTasks(
    { ...TASK_CLOSURE_QUERY, page: 0, size: 1, sort: TASK_CLOSURE_DEFAULT_SORT },
    { enabled: visible.tasks },
  )
  return {
    requests: requests.data?.page.totalElements,
    tasks: tasks.data?.page.totalElements,
  }
}
